export default __webpack_public_path__ + "static/media/002-chef.b9fd5f4f.svg";